module.exports = __webpack_public_path__ + "static/white-dragon-83f4e608328071791fb9abc243883983.png";